import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import theme from '@monorepo/shared/src/themes/defaultTheme';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import Config from '@monorepo/shared/src/config';
import { GroupTypes } from 'state/providers/AssignmentsProvider/types';
import { getIcon } from '../../Assignments/utils';

const tAssignment = (key, options?) => translate('assignment', key, options);

const EditAssignmentsHeader = ({ name }) => {
  const classes = useStyles();
  const icon = getIcon(GroupTypes.ALL);

  const goToPli = () => {
    const { pliUrl } = Config;
    window.location.replace(pliUrl as string);
  };

  return (
    <Box className={classes.headerContainer}>
      <Box>
        <Typography variant="h1" className={classes.headerTitle}>
          {icon} {name}
        </Typography>
        <Typography variant="subtitle1" className={classes.headerSubtitle}>
          {tAssignment('editAssignmentsSubtitle')}
        </Typography>
      </Box>
      <Box className={classes.headerButtonSection}>
        <Box>
          <Button onClick={goToPli}>
            <Typography className={classes.pliText} variant={'caption'}>
              <FontAwesomeIcon size="sm" icon={faCog} /> {tAssignment('managePLI')}
            </Typography>
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  headerContainer: {
    marginTop: 30,
    marginBottom: 25,
    display: 'flex',
    justifyContent: 'space-between',
  },
  headerTitle: {
    fontSize: remCalc(32),
    lineHeight: remCalc(48),
  },
  headerSubtitle: {
    fontSize: remCalc(16),
    lineHeight: remCalc(28),
  },
  headerButtonSection: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  pliText: {
    marginTop: 5,
    marginRight: 10,
    color: theme.palette.link.main,
    fontSize: remCalc(14),
  },
}));

export default EditAssignmentsHeader;
